exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rdp-tt { display: -webkit-inline-box !important; display: -ms-inline-flexbox !important; display: inline-flex !important;\n}\n", ""]);

// exports
